import { render, staticRenderFns } from "./centerLeft2.vue?vue&type=template&id=5e8704ba&scoped=true&"
import script from "./centerLeft2.vue?vue&type=script&lang=js&"
export * from "./centerLeft2.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft2.vue?vue&type=style&index=0&id=5e8704ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8704ba",
  null
  
)

export default component.exports